/** True if definition is a coded form flow. */
export function isCodedFormFlowDefinition(definition) {
    return "invokeCodedFormFlow" in definition && typeof definition.invokeCodedFormFlow === "function";
}
/** True if definition is a activity based form flow. */
export function isActivityBasedFlowDefinition(definition) {
    return "Activities" in definition && Array.isArray(definition.Activities);
}
